import { FaStar } from "react-icons/fa";

const StarRating = ({ rating, setRating }) => {
  return (
    <div style={{ display: "flex", gap: "5px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <FaStar
          key={star}
          size={24}
          style={{ cursor: "pointer" }}
          color={star <= rating ? "#ffc107" : "#e4e5e9"}
          onClick={() => setRating(star)}
        />
      ))}
    </div>
  );
};

export default StarRating;